export default __webpack_public_path__ + "static/media/8base-loader.15d680d6.gif";